import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { SH2 } from '@components/Typography'
import './style.css'

const CookiePopUp: React.FC = () => {
  const [cookies, setCookie] = useCookies(['npfsb-cookie-new'])
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [isVisibleInfo, setIsVisibleInfo] = useState<boolean>(false)

  useEffect(() => {
    if (!cookies['npfsb-cookie-new']) {
      setIsVisible(true)
    }
  })

  const clickHandler = () => {
    const expireDate = new Date()
    expireDate.setDate(expireDate.getDate() + 30)
    setCookie('npfsb-cookie-new', 'true', { expires: expireDate, path: '/',sameSite:'lax' })
    setIsVisible(false)
    setIsVisibleInfo(false)
  }

  return isVisible ? (
    <div className={`cookies-popup cookies-popup_visible ${isVisibleInfo?"cookies-popup_visible_agreement":""}`} id="cookies-popup">
      <div className="cookies-popup__overlay" onClick={() => setIsVisibleInfo(false)}></div>

      {isVisibleInfo && (
        <div className="cookies-popup__agreement-window">
          <svg
            className="cookies-popup__close"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => setIsVisibleInfo(false)}
          >
            <path d="M1 1L13 13" stroke="#9595A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M13 1L1 13" stroke="#9595A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <SH2 className="h2">Согласие на обработку персональных данных для посетителей сайта</SH2>
          <p>
            Продолжая работу на сайте, я выражаю свое согласие АО «НПФ Сбербанка» (адрес: 115162, г. Москва, ст. м.
            Шаболовская, ул. Шаболовка, д. 31Г, 4 подъезд, 3 этаж) на автоматизированную обработку моих персональных
            данных (файлы cookie, сведения о действиях пользователя на сайте, сведения об оборудовании пользователя,
            дата и время сессии), в т.ч. с использованием метрических программ Яндекс.Метрика, Google Analytics с
            совершением действий: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение),
            извлечение, использование, обезличивание, блокирование, удаление, уничтожение, передача (предоставление,
            доступ), в том числе трансграничная, партнёрам ПАО Сбербанк, предоставляющим сервис по указанным метрическим
            программам. Обработка персональных данных осуществляется в целях улучшения работы сайта, совершенствования
            продуктов и услуг АО «НПФ Сбербанка», определения предпочтений пользователя, предоставления целевой
            информации по продуктам и услугам АО «НПФ Сбербанка» и его партнеров.
          </p>
          <br />
          <p>
            Настоящее согласие действует с момента его предоставления и в течение всего периода использования сайта.
          </p>
          <br />
          <p>
            В случае отказа от обработки персональных данных метрическими программами я проинформирован о необходимости
            прекратить использование сайта или отключить файлы cookie в настройках браузера.
          </p>
          <SH2 className="h2">Условия и принципы обработки персональных данных в соответствии с GDPR*</SH2>
          <p>
            АО «НПФ Сбербанка» очень серьезно относится к вопросам конфиденциальности и безопасности информации. Защита
            ваших персональных данных** — один из наших ключевых приоритетов.
          </p>
          <br />
          <p>
            Мы обрабатываем ваши персональные данные, собранные на законных основаниях и в рамках четко сформулированных
            целей, характерных для взаимодействия АО «НПФ Сбербанка» со всеми сторонами:
          </p>
          <br />
          <ul>
            <li>- клиентами, потенциальными клиентами, их родственниками или представителями;</li>
            <li>- контрагентами и партнерами (как существующими, так и потенциальными);</li>
            <li>- сотрудниками (включая их родственников) и соискателями.</li>
          </ul>
          <br />
          <p>
            Мы можем собирать ваши персональные данные, информацию о предпочтениях, совершенных действиях и транзакциях
            и т.п. при помощи веб-сайта и мобильных приложений АО «НПФ Сбербанка» для заранее определенных и законных
            целей.
          </p>
          <br />
          <p>
            Мы можем передавать ваши персональные данные, в том числе трансгранично, строго при соблюдении требований
            законодательства.
          </p>
          <br />
          <p>
            Мы уважаем ваши права и свободы, в частности, связанные с вопросами обработки ваших персональных данных.
          </p>
          <br />
          <p>
            *GDPR – Регламент №2016/679 Европейского парламента и Совета Европейского Союза «О защите физических лиц при
            обработке персональных данных и о свободном обращении таких данных» General Data Protection Regulation
          </p>
          <br />
          <p>
            **Под термином «персональные данные» понимается любая информация, относящаяся к идентифицированному или
            идентифицируемому физическому лицу («субъект данных»). В состав персональных данных могут входить фамилия,
            имя, отчество, номер телефона, почтовый адрес, паспортные данные, сведения об образовании, доходах,
            предыдущих местах работы, а также другая информация, например, файлы cookie
          </p>{' '}
        </div>
      )}

      <div className="cookies-popup__cookies-window">
        <div className="cookies-popup__text">
          АО «НПФ Сбербанка» использует cookie (файлы с данными о прошлых посещениях сайта) для персонализации сервисов
          и удобства пользователей и серьезно относится к защите персональных данных - ознакомьтесь{' '}
          <a className="cookies-popup__trigger" target="_blank" onClick={() => setIsVisibleInfo(true)}>
            с условиями и принципами обработки персональных данных
          </a>
          , а также{' '}
          <a href="https://npfsberbanka.ru/upload/safety_recommendations.pdf" target="_blank" rel="noreferrer">
            с рекомендациями по защите информации.
          </a>{' '}
          Вы можете запретить сохранение cookie в настройках своего браузера.
        </div>
        <button className="button button_color_black button_size_text" type="button" onClick={clickHandler}>
          <div className="button__text">Ознакомлен </div>
        </button>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default CookiePopUp
